import type { Chapter } from "../types/common";

// 從前台選題清單隱藏的章節(純前端過濾，不動後端資料，清空此清單即還原）
// 2026-08-18 卡 117901 下架 4 筆 114 模考題；2026-09-30 卡 1003192 全數恢復，清單清空。
export const HIDDEN_CHAPTER_NAMES: readonly string[] = [];

export const filterHiddenChapters = (chapters: Chapter[]): Chapter[] => {
  const arr = Array.isArray(chapters) ? chapters : [];
  return arr.filter((ch) => !HIDDEN_CHAPTER_NAMES.includes(ch.chapter));
};
